export default __webpack_public_path__ + "static/media/spaceshooter.ae0d6432.png";